enum RefundTermStartDateSource {
  ContractEffectiveDate = 'ContractEffectiveDate',
  ContractCreatedAtLocal = 'ContractCreatedAtLocal',
}
export default RefundTermStartDateSource;
export type VerifyRefundTermStartDateSource = Utils.VerifyExtends<
  Model.Enum.RefundTermStartDateSource,
  Utils.ValueOf<typeof RefundTermStartDateSource>
>;
